import { Button, Grid, Typography } from "@mui/material";
import { Logo } from "components/Logo/Logo";
import { useLanguage } from "locale/useLanguage";
import Config from "Config";

import "./index.scss";

const DomainRedirectPage = () => {
  const [t] = useLanguage();

  const newUrl = `${Config.newAppOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`;

  const goToNewSite = () => {
    window.location.href = newUrl;
  };

  return (
    <div className="system-page domain-redirect-page">
      <div className="system-box domain-redirect-page__box">
        <div className="system-box__container domain-redirect-page__container animation scale-center-fade">
          <Grid container className="system-box--login" rowSpacing={2}>
            <Grid item xs={12} container justifyContent="center">
              <Logo style={{ height: "95px", width: "92px" }} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h5" component="h1" align="center" className="domain-redirect-page__title">
                {t("pages.domainRedirect.title")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" align="center" className="domain-redirect-page__description">
                {t("pages.domainRedirect.description")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" align="center" className="domain-redirect-page__new-url">
                <a href={newUrl}>{Config.newAppHostname}</a>
              </Typography>
            </Grid>
            <Grid item xs={12} container justifyContent="center">
              <Button
                size="large"
                variant="contained"
                className="domain-redirect-page__button"
                onClick={goToNewSite}
              >
                {t("pages.domainRedirect.go_to_new_site")}
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default DomainRedirectPage;
